import React from 'react';
import {Card, CardBody, CardHeader, Col, Collapse, Row} from "reactstrap";
import {Button, Select} from "semantic-ui-react";
import './notification_style.scss';
import {MDBDataTable} from "mdbreact";
import {DatePicker, Empty} from "antd";
import * as tbl_headers from '../tbl_colums';
import Cookies from "js-cookie";
import axiosTags from "../../../axios/axios_tag";
import apiConfig from "../../../axios/axios_api_services";
import * as common from "../../../const/Common/CommonFunc";
import * as actionCreator from "../../../store/Action";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import axiosSpace from "../../../axios/axios_spacetag";
import * as time_convertor_utils from "../../../util/TimeConvertor";
import swal from "sweetalert";
import are_you_sure_icon from "../../../assets/img/sweet/question.svg";
import moment from "moment";
import CreateNotificationModal from "./Create_Notification_Modal";

const {RangePicker} = DatePicker;

class WorkSpaceNotification extends React.Component {

  state = {

    create_notification_modal: false,

    corporateId: null,

    all_branch_list: [],
    branch_options: [],
    branch_index: 0,
    branch_id: 0,

    all_building_list: [],
    building_options: [],
    building_index: 0,
    building_id: 0,

    all_floor_list: [],
    floor_options: [],
    floor_index: 0,
    floor_id: 0,

    all_work_space_list: [],
    workspace_options: [],
    workspace_index: 0,
    workspace_id: 0,

    notification_history_list: [],

    title: "",
    message: "",

    start_date: null,
    end_date: null

  };

  componentDidMount() {
    this.props.systemChangeHandler(5);
    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    this.setState({
      corporateId: corporateId,
      branch_options: [
        {
          key: 0,
          text: "All",
          id: 0,
          value: 0,
        }
      ],
      floor_options: [
        {
          key: 0,
          text: "All",
          value: 0,
        }
      ],
      building_options: [
        {
          key: 0,
          text: "All",
          id: 0,
          value: 0,
        }
      ],
      workspace_options: [
        {
          key: 0,
          text: "All",
          id: 0,
          value: 0,
        }
      ],
      branch_index: 0,
      branch_id: 0,
      building_index: 0,
      building_id: 0,
      floor_index: 0,
      floor_id: 0,
      workspace_index: 0,
      workspace_id: 0

    });
    this.callAllBranches();
    // this.callAllWorkSpace(0,0,0, corporateId);
    this.loadNotificationHistory(0,0,0,0, corporateId);
  }

  callAllBranches = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    this.props.spinnerHandler(true);
    axiosTags.get(apiConfig.CORPORATE_BRANCH(this.props.usr_obj.corporateId), {headers: headers})
      .then(response => {
        if (response.data.success) {
          let branch_options = [
            {
              key: 0,
              text: "All",
              id: 0,
              value: 0,
            }
          ];
          if (response.data.branchList.length !== 0) {
            response.data.branchList.map((branch, index) => {

              const obj = {
                key: index + 1,
                text: branch.name,
                id: branch.branchId,
                value: index + 1,
                // value: branch.branchId
              };
              branch_options.push(obj)
            })
          }
          this.setState({
            branch_options: branch_options,
            all_branch_list: response.data.branchList
          })
        } else {
          this.setState({
            branch_options: []
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.callAllBranches()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  onChangeBranch = (e, {value}) => {

    let b_id = this.state.branch_options[value].id;

    this.setState({
      branch_index: value,
      branch_id: b_id,
      building_index: 0,
      building_id: 0,
      floor_options: [
        {
          key: 0,
          text: "All",
          value: 0,
        }
      ],
      floor_index: 0,
      floor_id: 0,
      workspace_options: [
        {
          key: 0,
          text: "All",
          id: 0,
          value: 0,
        }
      ],
      workspace_index: 0,
      workspace_id: 0
    });
    this.loadBuildings( value );
    this.loadNotificationHistory(b_id, 0, 0, 0, this.state.corporateId);
  };

  loadBuildings = ( index ) => {

    let building_options = [
      {
        key: 0,
        text: "All",
        id: 0,
        value: 0,
      }
    ];
    let buildings = null;
    if(index !== 0) {
      let branchOptions = this.state.all_branch_list;
      if(branchOptions) {
        let branchOption = branchOptions[index-1];
        buildings = branchOption.buildings;
        if(buildings) {
          buildings.map((result, index)=>{
            const obj = {
              key: index + 1,
              text: result.name,
              id: result.buildingId,
              value: index + 1,
            };
            building_options.push(obj);
          });
        }
      }
    }
    this.setState({
      building_options: building_options,
      all_building_list: buildings,
      building_index: 0,
      floor_options: [
        {
          key: 0,
          text: "All",
          value: 0,
        }
      ],
      floor_index: 0,
      floor_id: 0,
      workspace_options: [
        {
          key: 0,
          text: "All",
          id: 0,
          value: 0,
        }
      ],
      workspace_index: 0,
      workspace_id: 0
    });

  };

  onChangeBuilding = (e, { value }) => {
    let b_id = this.state.building_options[value].id;
    this.setState({
      building_index: value,
      building_id: b_id,
      floor_index: 0
    });
    this.loadFloors( value );
    this.loadNotificationHistory(this.state.branch_id, b_id, 0, 0, this.state.corporateId);
  };

  loadFloors = ( index ) => {

    let floor_options = [
      {
        key: 0,
        text: "All",
        value: 0,
      }
    ];
    let floors = [];
    if(index !== 0) {
      let floorOptions = this.state.all_building_list;
      if(floorOptions) {
        let floorOption = floorOptions[index-1];
        floors = floorOption.floors;
        if(floors) {
          floors.map((result, index)=>{
            const obj = {
              key: index + 1,
              text: result.description,
              id: result.floor_id,
              value: index + 1,
            };
            floor_options.push(obj);
          });
        }
      }
    }
    this.setState({
      all_floor_list: floors,
      floor_options: floor_options,
      floor_index: 0
    });

  };

  onChangeFloor = (e, {value}) => {
    this.setState({
      floor_id: this.state.floor_options[value].id,
      floor_index: value,
      workspace_id: 0,
      workspace_index: 0
    });
    this.callAllWorkSpace(this.state.branch_id, this.state.building_id, this.state.floor_options[value].id, this.state.corporateId);
    this.loadNotificationHistory(this.state.branch_id, this.state.building_id, this.state.floor_options[value].id, 0, this.state.corporateId);
  };

  callAllWorkSpace = (branchId, buildingId, floorId, corporateId) => {

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
      "Content-Type": "application/json"
    };

    let obj = {
      branchId : branchId,
      buildingId : buildingId,
      floorId : floorId,
    };

    this.props.spinnerHandler(true);
    axiosTags.post(apiConfig.ST_WORKSPACE_FILTER({ corporateId:corporateId }), obj, {headers: headers})
      .then(response => {
        if (response.data.success) {

          let ws_list = [];

          let s_obj = {
            key: 0,
            text: "All",
            id: 0,
            value: 0,
          };

          ws_list.push(s_obj);

          let d_list = response.data.workSpaceList;

          d_list.map((r, i)=>{
            let workSpaceId = r.workSpaceId;
            let description = r.description;
            let obj = {
              key: i+1,
              text: description,
              id: workSpaceId,
              value: i+1,
            };
            ws_list.push(obj);
          });

          this.setState({
            all_work_space_list: d_list,
            workspace_options: ws_list,
          });
        } else {

        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.callAllWorkSpace(branchId, buildingId, floorId, corporateId)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  onChangeWorkspace = (e, { value }) => {
    this.setState({
      workspace_id: this.state.workspace_options[value].id,
      workspace_index: value
    });
    this.loadNotificationHistory(this.state.branch_id, this.state.building_id, this.state.floor_id, this.state.workspace_options[value].id, this.state.corporateId);
  };

  loadNotificationHistory = (branch_id, building_id, floor_id, workspace_id, corporateId) => {

    let obj = {
      branchId: branch_id,
      buildingId: building_id,
      floorId: floor_id,
      workSpaceId: workspace_id
    };

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
      "Content-Type": "application/json"
    };

    this.props.spinnerHandler(true);
    axiosSpace.post(apiConfig.ST_GET_NOTIFICATION_HISTORY({ corporateId: corporateId }), obj, {headers: headers})
      .then(response => {
        if(response.status === 200) {
          if (response.data.success) {
            let r = response.data.notificationDetailsDTOS;
            if(r !== null && r !== undefined && r !== "") {
              if(r.length>0) {
                r.reverse();
                this.setState({
                  notification_history_list: r
                });
              }
            }
          } else {

          }
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.loadNotificationHistory(branch_id, building_id, floor_id, workspace_id, corporateId);
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  openCreateNotifictionModal = () => {
    this.setState({
      create_notification_modal: !this.state.create_notification_modal
    });
    this.loadAfterCloseModal();
  };

  loadAfterCloseModal = () => {
    if(this.state.create_notification_modal) {
      this.loadNotificationHistory(this.state.branch_id, this.state.building_id, this.state.floor_id, this.state.workspace_id, this.state.corporateId);
    }
  };

  render() {

    let { branch_options, building_options, floor_options, workspace_options, branch_index, building_index, floor_id, workspace_id, floor_index, workspace_index, notification_history_list, title, message } = this.state;

    let row = [];

    if(notification_history_list) {
      if(notification_history_list.length!==0) {
        let nl = notification_history_list;
        nl.map((r, i)=>{
          let datetime = time_convertor_utils.convertDateObjStringToHumenReadable(r.time);
          let obj = {
            date: datetime,
            workspace: (r.branchName !== null)?
              (r.buildingName !== null)?
                (r.floorName !== null)?
                  (r.workSpaceName !== null)?
                    r.coperateName + " > " + r.branchName + " > " + r.buildingName + " > " + r.floorName + " > " + r.workSpaceName:
                    r.coperateName + " > " + r.branchName + " > " + r.buildingName + " > " + r.floorName:
                  r.coperateName + " > " + r.branchName + " > " + r.buildingName:
                r.coperateName + " > " + r.branchName:
              r.coperateName,
            title: r.title,
            notification: r.body
          };
          row.push(obj);
        })
      }
    }

    let notification_history = {columns: tbl_headers.NOTIFICATION_HEADERS, rows: row};

    let dateRange = null;

    if (this.state.start_date !== null && this.state.start_date !== undefined && this.state.start_date !== "") {
      let startdate = this.state.start_date;
      let enddate = this.state.end_date;
      dateRange = [moment(startdate), moment(enddate)];
    } else {
      dateRange = null;
    }

    return(
      <div>
        {
          this.state.create_notification_modal?
            <CreateNotificationModal isOpen={true} closeModal={this.openCreateNotifictionModal}/>:null
        }
        <Row>
          <Col className={'text-right new-notifi-btn-space'}>
            <Button
              className="px-5"
              onClick={this.openCreateNotifictionModal}
            ><i aria-hidden="true" className="plus icon"></i>
              New Notification
            </Button>
          </Col>
        </Row>
        <Card>
          <CardHeader>
            Filter Workspace
          </CardHeader>
          <Collapse isOpen={true} id="collapseExample">
            <CardBody>
              <Row>
                <Col>
                  <div>
                    <div>Branch</div>
                    <Select
                      placeholder='Select branch'
                      options={ branch_options }
                      value={ branch_index }
                      onChange={ this.onChangeBranch }
                    />
                  </div>
                </Col>
                <Col>
                  <div>
                    <div>Building</div>
                    <Select
                      placeholder='Select building'
                      options={ building_options }
                      value={ building_index }
                      onChange={ this.onChangeBuilding }
                    />
                  </div>
                </Col>
                <Col>
                  <div>
                    <div>Floor</div>
                    <Select
                      placeholder='Select floor'
                      options={ floor_options }
                      value={ floor_index }
                      onChange={ this.onChangeFloor }
                    />
                  </div>
                </Col>
                <Col>
                  <div>
                    <div>Workspace</div>
                    <Select
                      placeholder='Select workspace'
                      options={ workspace_options }
                      value={ workspace_index }
                      onChange={ this.onChangeWorkspace }
                    />
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Collapse>
        </Card>
        <Card>
          <CardHeader>
            Notification History
          </CardHeader>
          <Collapse isOpen={true} id="collapseExample">
            <CardBody>
              {
                true ?
                  <MDBDataTable
                    searching={true}
                    displayEntries={true}
                    responsive
                    responsiveSm
                    responsiveMd
                    responsiveLg
                    responsiveXl
                    bordered
                    hover
                    data={notification_history}
                  />
                  : <div className={"align-center fully-width"}>
                    <Empty description={"Records not found"} className={"empty-icon"}/>
                  </div>
              }
            </CardBody>
          </Collapse>
        </Card>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    workspaceHandler: (data) => dispatch(actionCreator.workspaceSaveHandler(data)),
    workspaceRemove: () => dispatch(actionCreator.workspaceRemoveHandler()),
    systemChangeHandler: (data) => dispatch(actionCreator.systemChangeHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(WorkSpaceNotification));
